import React from "react";

export const BoldText = ({ prop }) => {
    return <span style={{ fontWeight: 600 }}>{prop}</span>;
};
